export default "__VITE_ASSET__BnVg$FJ0__"